/*
 * @Description: 地图点位（POI）— E1「列表」本地 mock。
 *   iconUrl 用正式预设图标 OSS url，列表/地图展示真实分类图标。
 */
import { PoiListData } from '../types/poi.types'

const ICON_CUSTOMER =
  'https://net-cloud.xhey.top/data/006f43ee-3067-459f-b3a2-c9924f5ce2e3.png'
const ICON_PATROL =
  'https://net-cloud.xhey.top/data/1ee39125-3bed-40ba-bf1e-cb7a183b8596.png'
const ICON_SITE =
  'https://net-cloud.xhey.top/data/df361e30-d1f1-41e2-981d-0976e1f059e1.png'

export const MOCK_POI_LIST: PoiListData = {
  total: 5,
  items: [
    {
      id: 1,
      name: '客户A–天府总部',
      iconUrl: ICON_CUSTOMER,
      address: '天府大道北段128号',
      lng: 104.0668,
      lat: 30.5728,
      createdAt: 1773504000000
    },
    {
      id: 2,
      name: '仓库B–上地基地',
      iconUrl: ICON_SITE,
      address: '海淀区上地三街56号',
      lng: 116.3184,
      lat: 40.0356,
      createdAt: 1773504000000
    },
    {
      id: 3,
      name: '巡检点1–中心绿地',
      iconUrl: ICON_PATROL,
      address: '海淀区上地三街中心绿地',
      lng: 116.3215,
      lat: 40.0412,
      createdAt: 1773763200000
    },
    {
      id: 4,
      name: '客户B–软件园',
      iconUrl: ICON_CUSTOMER,
      address: '中关村软件园二期',
      lng: 116.3098,
      lat: 40.0489,
      createdAt: 1773936000000
    },
    {
      id: 5,
      name: '巡检点2–东门入口',
      iconUrl: ICON_PATROL,
      address: '怡泉新景小区东门',
      lng: 116.3256,
      lat: 40.0378,
      createdAt: 1773936000000
    }
  ]
}
